import React from 'react';
import {FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiMapPin, FiPhone} from "react-icons/fi";
import {RiWhatsappLine} from "react-icons/ri";
import {Link} from "react-router-dom";
import {FaTelegram} from "react-icons/all";

const HeaderTopBar = () => {
    return (
        <div className="header-top-bar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="header-left">
                            <p><a href='https://goo.gl/maps/985VUt8fCcQUUc2c6' target='_blank'><FiMapPin/> Jethalal
                                Chambers, Nairobi, Kenya</a></p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="header-right">
                            <div className="address-content">
                                <p><span><a href="https://wa.me/message/T2OTCJMZ3EK6H1" target='_blank'
                                            rel="noreferrer"><RiWhatsappLine/>+254 713 958 492</a></span></p>
                                <p><span><a href="tel:0713958492"><FiPhone/>+254 713 958 492</a></span></p>
                            </div>
                            <div className="social-icon-wrapper">
                                <ul className="social-icon social-default icon-naked">
                                    <li><a href="https://www.facebook.com/mixonsoftwares/"
                                           target="_blank"><FiFacebook/></a></li>
                                    <li><a href="https://twitter.com/mixonsoftwares/"
                                           target="_blank"><FiTwitter/></a></li>
                                    <li><a href="https://www.instagram.com/mixonsoftwares/"
                                           target="_blank"><FiInstagram/></a></li>
                                    <li><a href="https://www.linkedin.com/company/mixonsoftwares/"
                                           target="_blank"><FiLinkedin/></a></li>
                                    <li><a href="https://www.linkedin.com/company/mixonsoftwares/"
                                           target="_blank"><FaTelegram/></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopBar;
